import { useAuth0 } from '@auth0/auth0-react';
import { ButtonV2, InputV2 } from '@cimplico/components';
import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import { ReactComponent as EmailIcon } from '../assets/email.svg';
import { toastNotification } from '../components/toast/Toast';
import { useVerifyEmail } from '../queries/use-send-verificaion-email';

function ResendEmailVerification(): JSX.Element {
    const { logout } = useAuth0();
    const [request, setRequest] = useState(false);
    const [email, setEmail] = useState('');
    const { mutate, isLoading } = useVerifyEmail();

    function sendEmail(): void {
        if (!email) return;
        mutate(
            { email },
            {
                onSuccess: () => {
                    toastNotification('success', 'Successfully sent verification email.');

                    toggleRequest();
                },
                onError: (err) => {
                    toastNotification('error', 'Unable to send verification email.', err.response?.data?.message ?? 'Something went wrong');
                },
            }
        );
    }

    function toggleRequest(): void {
        setEmail('');
        setRequest(!request);
    }

    return (
        <div className="flex items-center justify-center gap-16 h-screen w-screen">
            <EmailIcon className="h-[200px] w-[200px]" />
            {request ? (
                <form
                    className="w-[480px] flex flex-col"
                    onSubmit={(e): void => {
                        e.preventDefault();
                        sendEmail();
                    }}
                >
                    <h1 className="text-2xl text-gray-800 font-bold">Enter your email</h1>
                    <p className="text-sm text-gray-600 mb-4">Enter your email address to resend your verification email.</p>
                    <InputV2 type="text" placeholder="Email" autoFocus onChange={setEmail} />
                    <div className="mt-2 w-full inline"></div>
                    <ButtonV2 size="sm" label="Send" isDisabled={!email || isLoading} isLoading={isLoading} isSubmit />
                    <button onClick={(): Promise<void> => logout()} className="flex items-center text-sm text-gray-600 gap-1 mt-4 -ml-1">
                        <ChevronLeftIcon className="h-6 w-6 text-gray-800" /> Back to Login
                    </button>
                </form>
            ) : (
                <div className="w-[480px]">
                    <h1 className="text-2xl text-gray-800 font-bold">Check Email</h1>
                    <p className="text-sm text-gray-600">
                        Please check your inbox and click the link to verify your account.
                        <br />
                        If you did not receive it, check your spam folder or&nbsp;
                        <button className="text-indigo-600 font-bold" onClick={toggleRequest}>
                            request another email
                        </button>
                        .
                    </p>
                    <button onClick={(): Promise<void> => logout()} className="flex items-center text-sm text-gray-600 gap-1 mt-4 -ml-1">
                        <ChevronLeftIcon className="h-6 w-6 text-gray-800" /> Back to Login
                    </button>
                </div>
            )}
        </div>
    );
}

export default ResendEmailVerification;
